if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability-section`;
        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");

        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");

        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer")
        );

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            const drawer = document.querySelector("pickup-availability-drawer");
            drawer.classList.add("active");
            drawer.setAttribute("aria-hidden", "false");
            document.body.classList.add("overflow-hidden");
            lenis.stop();

            const focusableElements = drawer.querySelectorAll("button, input, a");
            focusableElements.forEach((el) => {
              el.setAttribute("tabindex", "0");
            });

            if (focusableElements.length) {
              focusableElements[0].focus();
            }

            drawer.addEventListener("keydown", (event) => trapFocus(event, drawer));
          });
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        let lastFocusedButton = document.querySelector(
          ".pickup_availability_btn"
        );

        this.querySelector("button").addEventListener("click", () => {
          const drawer = document.querySelector("pickup-availability-drawer");
          closeDrawer(this);

        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") closeDrawer(this);
        });
               
        this.addEventListener("click", () => {
          if (event.target === this) {
            closeDrawer(this);            
          }
        });

        function closeDrawer(drawer) {
          if (drawer) {
            drawer.classList.remove("active");
            drawer.setAttribute("aria-hidden", "true");
            document.body.classList.remove("overflow-hidden");
            lenis.start();
            let lastFocusedButton = document.querySelector(".pickup_availability_btn");

            if (lastFocusedButton) {
              lastFocusedButton.focus();
              lastFocusedButton = null;
            }
          }
        }
      }
    }
  );
}
